import { render, staticRenderFns } from "./saleOrder.vue?vue&type=template&id=4d903d1a&scoped=true&"
import script from "./saleOrder.vue?vue&type=script&lang=js&"
export * from "./saleOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d903d1a",
  null
  
)

export default component.exports